import { useState } from "react";
import DynamicForm from "./DynamicForm";

export default function QuestionsForm({ incidentType, answers, onAnswersChange, fileMap, onFileChange, onSubmit, onBack, submitting, submitError }) {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    incidentType.questions.forEach((field) => {
      if (field.type === "attachment") return;
      const val = answers[field.id];
      if (val === undefined || val === null || val === "") {
        errs[field.id] = "This field is required.";
      }
    });
    return errs;
  };

  const handleSubmit = () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setErrors({});
    onSubmit();
  };

  const handleChange = (id, value) => {
    onAnswersChange({ ...answers, [id]: value });
    if (errors[id]) setErrors((e) => ({ ...e, [id]: undefined }));
  };

  return (
    <div className="form-card">
      <h2 className="card-title">{incidentType.label}</h2>
      <p className="card-subtitle">Step 2 of 2 — Provide additional details about the incident.</p>

      <div className="form-section">
        <div className="form-section-title">Questions</div>
        <DynamicForm
          fields={incidentType.questions}
          answers={answers}
          onAnswerChange={handleChange}
          fileMap={fileMap}
          onFileChange={onFileChange}
          errors={errors}
        />
      </div>

      {submitError && <div className="error-banner">{submitError}</div>}

      <div className="btn-row">
        <button className="btn-secondary" onClick={onBack} disabled={submitting}>Back</button>
        <button className="btn-primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Submitting…" : "Submit Report"}
        </button>
      </div>
    </div>
  );
}
